import { cloneDeep } from "lodash";
import { convertOpenAIToCopilot } from "./convert-openai-to-copilot";
/** Slices a range of OpenAI messages into batched CopilotKit conversation objects grouped by tool-call chains. */
export function convertOpenAIToCopilotMessages(openaiMessages, startIndex, endIndex) {
  var startMessageIndex = startIndex;
  var lastMessageIndex = endIndex;
  var copilotConversations = [];
  while (startMessageIndex <= lastMessageIndex) {
    var _msg$tool_calls;
    var msg = openaiMessages[startMessageIndex];
    var toolCallMesages = [];
    if (msg.role === "assistant" && msg.tool_calls && ((_msg$tool_calls = msg.tool_calls) === null || _msg$tool_calls === void 0 ? void 0 : _msg$tool_calls.length) === 0) {
      startMessageIndex++;
      while (startMessageIndex <= lastMessageIndex && openaiMessages[startMessageIndex].role !== "user" && openaiMessages[startMessageIndex].role !== "system" && !(openaiMessages[startMessageIndex].role === "assistant" && openaiMessages[startMessageIndex].tool_calls && ((_openaiMessages$start = openaiMessages[startMessageIndex].tool_calls) === null || _openaiMessages$start === void 0 ? void 0 : _openaiMessages$start.length) === 0)) {
        var _openaiMessages$start;
        toolCallMesages.push(openaiMessages[startMessageIndex]);
        startMessageIndex++;
      }
      var _toolCallCopilotMessages = convertOpenAIToCopilot(toolCallMesages.reverse(), true);
      var _copilotConversation = convertOpenAIToCopilot([msg])[0];
      copilotConversations.push({
        toolCalls: _toolCallCopilotMessages,
        message: _copilotConversation
      });
    } else {
      var _copilotConversation2 = convertOpenAIToCopilot([msg])[0];
      copilotConversations.push({
        toolCalls: [],
        message: _copilotConversation2
      });
      startMessageIndex++;
    }
  }
  var _copilotConversations = cloneDeep(copilotConversations);
  return {
    copilotConversations: _copilotConversations.reverse(),
    startMessageIndex: startMessageIndex
  };
}